import React, { useState, useEffect } from 'react';
import { Col, Row, Image, Dropdown, } from 'react-bootstrap';
import styles from './hiringPipelines.module.scss';
import { CustomSearch } from '../../shared/customSearch';
import { CustomButton } from '../../shared/customButton';
import { getAllPipelines, clonePipeline, updateShareableLinkStatus, pinnedPipeline } from '../../../services/util/hiringpipeline';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../customNavbar';
import CSSLoader from '../../shared/cssLoader';
import { CreatePipelineModal } from './createPipelineModal';
import InitialGuide from './initialGuide';
import makeAnimated from 'react-select/animated';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select'
import { CustomConfirmationModal } from '../../shared/customConfirmationModal';
import { CustomStatusLabel } from '../../shared/customStatusLabel';
import { CustomCloneConfirmationBox } from '../../shared/customCloneConfirmationBox';
import { toast } from 'react-toastify';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomIconButton } from '../../shared/customIconButton';
import { CustomPreIcon } from '../../shared/customPreIcon';
let moment = require("moment");

const HiringPipelines = (props) => {


    // States
    let [isPageDataLoading, setIsPageDataLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    let [value, setArrayValues] = useState([]);
    let [filteredValues, setFilteredValues] = useState([]);
    let [showNewUserGuide, setShowNewUserGuide] = useState(false);
    let [newUserGuide, setNewUserGuide] = useState(null);
    const [isCloneModalOpen, setCloneModalOpen] = useState(false);
    const [isSubmit, setSubmit] = useState(false);
    const [selectID, setSelectedID] = useState(null);
    const [pipelineId, setPipelineID] = useState(false);
    let [shareableLinkModal, setShareableLinkModal] = useState(false);
    let [disableLinkLoading, setDisableLinkLoading] = useState(false);
    let [isLoadingActivision, setLoadingActivision] = useState(false);

    const animatedComponents = makeAnimated();


    const history = useNavigate();
    //getting query parameter value
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let seleted_state = (params.get('state') ? params.get('state') : 0);

    //set an state for default seleted pipeline type
    let [defaultSelectedPipelineType, setDefaultSelectedPipelineType] = useState({
        label: "Active and Draft",
        value: 0
    })
    //dropdown values of pipeline types
    const pipelineTypes = [
        {
            label: "Active and Draft",
            value: 0
        },
        {
            label: "Active",
            value: 10
        },
        {
            label: "Draft",
            value: 20
        },
        {
            label: "Disabled",
            value: 30
        }
    ];

    let [noSearchData, setNoSearchData] = useState(false)

    //on change pipeline type

    const changePipelineType = async (type) => {
        setIsPageDataLoading(true);
        setDefaultSelectedPipelineType(type);
        let respond = await getAllPipelines(type.value);
        if (respond.success === true) {
            setArrayValues(respond.data.pipeline_array)
            setFilteredValues(respond.data.pipeline_array)
            if (respond.data.new_user_guide) {
                setShowNewUserGuide(true);
                setNewUserGuide(respond.data.new_user_guide);
            }
            setIsPageDataLoading(false)
        } else {
            setIsPageDataLoading(false)
        }

    };


    const breadcrumb = [{
        pathaddress: '/app/company/pipelines',
        pathname: 'Vacancy Pipelines',
        isActive: false,
        key: 1 + 'hiring-pipeline'
    }]

    const breacrumbText = 'Vacancy pipeline is a workflow starting from sourcing candidates to finally onboarding them. Create separate pipelines for each vacancy.'


    // functions
    const handleCloseCreatePipelineModal = () => setShowModal(false);
    const handleShowCreatePipelineModal = () => {
        setShowModal(true);
    }

    function viewPipeline(value) {
        props.history(`/company/pipelines/${value}`);
    }

    function editPipelineBtnClicked(value) {
        history(`/company/pipelines/${value}/edit`);
    }

    //clone pipeline
    function onClickClone(value) {
        setCloneModalOpen(true);
        setSelectedID(value)
    }

    //submit clone values function
    async function submitCloneValues(values) {
        setSubmit(true)
        let respond = await clonePipeline(selectID, values.newCloneName)
        if (respond.success === true) {
            setSelectedID(null);
            history(`/company/pipelines`);
            setSubmit(false);
            setCloneModalOpen(false);
        } else {
            setSubmit(false);
            setCloneModalOpen(false);
        }
        window.location.reload();
    }

    function searchValus(searchValue) {
        let searchVal = searchValue.toLowerCase();
        const filtered = value.filter(entry => Object.values(entry).some(val => typeof val === "string" && (val.toLowerCase()).includes(searchVal)));
        setFilteredValues(filtered);
        if (filtered.length === 0) {
            setNoSearchData(true)
        }
    }


    const getAllPipelinesValues = async () => {
        setIsPageDataLoading(true)
        let respond = await getAllPipelines(seleted_state);
        if (respond.success === true) {
            setArrayValues(respond.data.pipeline_array)
            setFilteredValues(respond.data.pipeline_array)
            if (respond.data.new_user_guide) {
                setShowNewUserGuide(true);
                setNewUserGuide(respond.data.new_user_guide);
            }
            //setting pipleine label for selected state
            if (seleted_state != 100) {
                for (let index = 0; index < pipelineTypes.length; index++) {
                    if (pipelineTypes[index].value == seleted_state) {
                        setDefaultSelectedPipelineType(pipelineTypes[index]);

                    }
                }
            }
            setIsPageDataLoading(false);
        } else {
            setIsPageDataLoading(false)
        }
    }

    const changeSelectedStateURL = async (state) => {
        setCurrentPage(1)
        history({
            pathname: `/company/pipelines`,
            search: `?state=${state}`
        });
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            className={styles.userIcon}
            href=""
            ref={ref}
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <div className={styles.svgIconsMainDiv}>
                <div className={styles.userIconSvgDiv}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10.0001 10.8333C10.4603 10.8333 10.8334 10.4602 10.8334 9.99992C10.8334 9.53968 10.4603 9.16659 10.0001 9.16659C9.53984 9.16659 9.16675 9.53968 9.16675 9.99992C9.16675 10.4602 9.53984 10.8333 10.0001 10.8333Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 4.99992C10.4603 4.99992 10.8334 4.62682 10.8334 4.16659C10.8334 3.70635 10.4603 3.33325 10.0001 3.33325C9.53984 3.33325 9.16675 3.70635 9.16675 4.16659C9.16675 4.62682 9.53984 4.99992 10.0001 4.99992Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M10.0001 16.6666C10.4603 16.6666 10.8334 16.2935 10.8334 15.8333C10.8334 15.373 10.4603 14.9999 10.0001 14.9999C9.53984 14.9999 9.16675 15.373 9.16675 15.8333C9.16675 16.2935 9.53984 16.6666 10.0001 16.6666Z" stroke="#98A2B3" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                {children}
            </div>
        </a>
    ));

    function copyURL(value) {
        navigator.clipboard.writeText(value)
        toast.success(<div>Link Copied!</div>, {
            position: "top-right",
            autoClose: 2500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    }

    function navigateURL(value) {
        window.open(value);
    }

    //shareable link enable
    const changeShareableLinkState = async (pipelineId, Status) => {

        setPipelineID(pipelineId);
        let pipeline_id = pipelineId;
        if (Status === true) {
            setShareableLinkModal(true);
        } else {
            setLoadingActivision(true)
            let respond = await updateShareableLinkStatus(pipeline_id);
            if (respond.success === true) {
                setLoadingActivision(false);
                getAllPipelinesValues();
            } else {
                setLoadingActivision(false)
            }
        }
    }

    //shareable link disable
    const disableLink = async () => {
        setDisableLinkLoading(true)
        let respond = await updateShareableLinkStatus(pipelineId);
        if (respond.success === true) {
            getAllPipelinesValues();
            setDisableLinkLoading(false);
            setShareableLinkModal(false);

        } else {
            setDisableLinkLoading(false)
        }
    }
    const changePinState = async (pipelineId, isPinned) => {

        let respond = await pinnedPipeline(pipelineId, isPinned);
        if (respond.success === true) {
            getAllPipelinesValues()
            if (isPinned === true) {
                toast.success(<div>Pipeline Pinned!</div>, {
                    position: "top-right",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            else {
                toast.success(<div>Pipeline Unpinned!</div>, {
                    position: "top-right",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } else {
            toast.warning(<div>There was an error!</div>, {
                position: "top-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }

    }

    const itemsPerPage = 9; // Number of items to display per page
    const [currentPage, setCurrentPage] = useState(1); // Current page number

    const handlePreviousClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextClick = () => {
        const totalPages = Math.ceil(filteredValues.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const totalPages = Math.ceil(filteredValues.length / itemsPerPage);

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            getAllPipelinesValues();
        }
        return () => { unmounted = true };
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    // View
    return (
        <div>
            <Helmet>
                <title>Vacancy Pipelines | HireTrace</title>
            </Helmet>

            {/* Modal View Start */}
            {
                showModal === true ?
                    <CreatePipelineModal show={showModal} handleClose={handleCloseCreatePipelineModal} stepLength={3} />
                    : null
            }

            {/* Modal View End */}

            {/* submit result alert confirmation start */}
            {
                <CustomCloneConfirmationBox
                    show={isCloneModalOpen}
                    confirmationType='default'
                    cancelIconclick={() => setCloneModalOpen(false)}
                    onSecondaryBtnClick={() => setCloneModalOpen(false)}
                    onFormSubmit={submitCloneValues}
                    isSecondaryBtnDisabled={isSubmit === true ? true : false}
                    isPrimaryBtnDisabled={isSubmit === true ? true : false}
                    primaryBtnBackSideIcon={isSubmit === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    preCheckedCondition={true}
                    topic="Clone Pipeline"
                    message={`You are trying to clone a pipeline.`}
                    textBoxLabel={`Enter new pipeline name`}
                    secondaryBtnName="backBtn"
                    secondaryBtnType="button"
                    secondaryBtnCssType="primaryBtn"
                    secondaryBtnLabel="Cancel"
                    primaryBtnName="submitCloneBtn"
                    primaryBtnType="submit"
                    primaryBtnId="adminPanel_hiringPipelines_clonePipeline_yesClonePipelineBtnId"
                    primaryBtnCssType="successBtn"
                    primaryBtnLabel="Yes, clone pipeline"
                    textBoxPlaceholder={`Ex: Software Engineer Pipeline`}
                />}
            {/* submit result alert confirmation end */}

            {/* Custom popup link turn off start */}
            {
                <CustomConfirmationModal
                    show={shareableLinkModal}
                    confirmationType='danger'
                    cancelIconclick={() => setShareableLinkModal(false)}
                    onSecondaryBtnClick={() => setShareableLinkModal(false)}
                    onPrimaryBtnClick={disableLink}
                    isSecondaryBtnDisabled={disableLinkLoading === true ? true : false}
                    isPrimaryBtnDisabled={disableLinkLoading === true ? true : false}
                    primaryBtnBackSideIcon={disableLinkLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                    confirmationTopic="Are you sure?"
                    confirmationMessage="Afterwords you turn off link sharing, only invited and manually uploaded candidates will be able to register with the pipeline!"
                    secondaryBtnName="backBtn"
                    secondaryBtnType="button"
                    secondaryBtnCssType="primaryBtn"
                    secondaryBtnLabel="Cancel"
                    primaryBtnName="submitBtn"
                    primaryBtnType="button"
                    primaryBtnCssType="dangerBtn"
                    primaryBtnLabel="Yes, turn off!"
                />
            }

            {/* Custom popup link turn off end */}

            {isPageDataLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                        {showNewUserGuide ?
                            <Row className="d-flex flex-row-reverse">
                                <Col sm={3} className="mb-2 ">
                                    <div className={showNewUserGuide ? styles.activateBtnBlink : ''}>
                                        <CustomButton
                                            buttonType="button"
                                            label="Create New Pipeline"
                                            type="primaryBtn"
                                            id="adminPanel_hiringPipelines_createNewPipelineBtnId"
                                            frontIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10.0001 4.16675V15.8334M4.16675 10.0001H15.8334" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            handleClick={handleShowCreatePipelineModal}
                                            disabled={
                                                props.permissions.actions.edit_pipeline === false ? true : false
                                            }
                                            toolTipId={props.permissions.actions.edit_pipeline === false && "permissionError"}
                                            toolTip={props.permissions.actions.edit_pipeline === false && "Permission Denied"}
                                            showToolTip={props.permissions.actions.edit_pipeline === false ? true : false}

                                        />
                                    </div>
                                </Col>
                            </Row>
                            :
                            <Col className={styles.controlsBarBox}>
                                <div>
                                    <Row className='d-flex'>
                                        <Col sm={2} className="mb-1">
                                            <Select
                                                options={pipelineTypes}
                                                class="react-select__control"
                                                id="adminPanel_hiringPipelines_pipelineTypeDrodownId"
                                                components={animatedComponents}
                                                value={defaultSelectedPipelineType}
                                                onChange={(e) => {
                                                    changePipelineType(e);
                                                    changeSelectedStateURL(e.value)
                                                }}
                                                styles={
                                                    {
                                                        ...styles,
                                                        control: (base, state) => ({
                                                            ...base,
                                                            '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                            border: '1px solid #D0D5DD', // default border color
                                                            borderRadius: '6px',
                                                            boxShadow: 'none', // no box-shadow
                                                            height: '44px',
                                                            fontFamily: 'var(--app-primary-font-style)',
                                                            fontWeight: 'var(--app-regular-font-weight)',
                                                            fontSize: 'var(--app-primary-font-size)',
                                                        }),
                                                        option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                            return {
                                                                ...styles,
                                                                background: isDisabled
                                                                    ? null
                                                                    : isSelected
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : isFocused
                                                                            ? 'rgba(45, 166, 192, 0.1)'
                                                                            : null,
                                                                color: isDisabled
                                                                    ? '#ccc'
                                                                    : isSelected
                                                                        ? '#24859A'
                                                                        : '#24859A',
                                                                cursor: isDisabled ? 'not-allowed' : 'default',

                                                                ':active': {
                                                                    ...styles[':active'],
                                                                    background:
                                                                        !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                                },
                                                            };
                                                        },
                                                    }
                                                }
                                            />
                                        </Col>
                                        <Col sm={7} className="mb-1">
                                            <CustomSearch
                                                placeholder="Search pipeline name"
                                                handleOnChange={(e) => searchValus(e.target.value)}
                                            />
                                        </Col>

                                        <Col sm={3} className="mb-1">
                                            <CustomButton
                                                buttonType="button"
                                                label="Create New Pipeline"
                                                type="primaryBtn"
                                                id="adminPanel_hiringPipelines_createNewPipelineBtnId"
                                                frontIcon={
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M10.0001 4.16675V15.8334M4.16675 10.0001H15.8334" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                }
                                                handleClick={handleShowCreatePipelineModal}
                                                disabled={
                                                    props.permissions.actions.edit_pipeline === false ? true : false
                                                }
                                                toolTipId={props.permissions.actions.edit_pipeline === false && "permissionError"}
                                                toolTip={props.permissions.actions.edit_pipeline === false && "Permission Denied"}
                                                showToolTip={props.permissions.actions.edit_pipeline === false ? true : false}

                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        }
                    </div>

                    <div className={styles.tableBodyContainer}>
                        {
                            ((filteredValues.length === 0) && (isPageDataLoading === false)) ?
                                (<div>
                                    {showNewUserGuide ? <InitialGuide userGuide={newUserGuide} toggleCreatePipeline={handleShowCreatePipelineModal} />
                                        :
                                        <>
                                            {noSearchData ?
                                                <Col>
                                                    <p className={styles.infoMessage}>No records found for your search, Try a different keyword. </p>
                                                </Col>
                                                :
                                                <div>
                                                    <Col>
                                                        <p className={styles.infoMessage}>Start Hiring with <a href='https://hiretrace.io/documentation/getting-started/101' target="_blank">Getting Started Guideline</a>. Or Learn more
                                                            about  <a href='https://hiretrace.io/documentation/hiring-pipeline/overview' target="_blank">Vacancy Pipelines</a>. </p>
                                                    </Col>
                                                    <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/startPipeline.svg`} fluid />
                                                    </Col>
                                                </div>
                                            }

                                        </>

                                    }

                                </div>)
                                :
                                (<div className={styles.tableContainer}>
                                    <div className={styles.tableFirstRowMainHeaderDiv}>
                                        <Col sm={4} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                            <p>Pipeline</p>
                                        </Col>
                                        <Col sm={1} className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                            <p>Status</p>
                                        </Col>
                                        <Col sm={2}>
                                            <Row className={styles.tableDetailsMainHeaderRowLeftAligned}>
                                                <p>Role Type</p>
                                            </Row>
                                        </Col>
                                        <Col sm={2} className="d-flex justify-content-center">
                                            <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                <p className={styles.candidateStatusHeader}>Candidate  A / P / H</p>
                                                <div className={styles.tableInfoDetailsHeaderIcon}>
                                                    <svg data-tooltip-id={`status`} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                                    <ReactTooltip id={`status`} place="bottom" type="dark" effect="float" clickable={true}>
                                                        <div className={styles.toolTipBox}>{<p>Applied / Pending at Offer / Hired</p>}</div>
                                                    </ReactTooltip>
                                                </div>

                                            </Row>
                                        </Col>
                                        <Col sm={1} className="d-flex justify-content-center">
                                            <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                <p>Vacancy Page</p>
                                            </Row>
                                        </Col>
                                        <Col sm={1} className="d-flex justify-content-center">
                                            <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                <p>Created at</p>
                                            </Row>
                                        </Col>
                                        <Col sm={1} className="d-flex justify-content-center">
                                            <Row className={styles.tableDetailsMainHeaderRowCentered}>
                                                <p>Actions</p>
                                            </Row>
                                        </Col>
                                    </div>
                                    {filteredValues?.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((pipeline, i) => {
                                        return (
                                            <div className={i % 2 === 0 ? styles.tableRowMainDiv : styles.tableRowSecondMainDiv}>
                                                <Col sm={4} onClick={() => viewPipeline(pipeline.pipeline_id)} className={styles.tableClickableArea} id={`adminPanel_hiringPipelines_pipelineTablePipelineRowId.${i}`}>
                                                    <Row className={styles.tableFirstColumnData}>
                                                        <Col sm={2} >
                                                            <div className={styles.tableMainIconDiv}>
                                                                <CustomPreIcon
                                                                    type={pipeline.state === 10 ? 'successIcon' : pipeline.state === 0 ? 'warningIcon' : pipeline.state === -10 ? 'dangerIcon' : ''}
                                                                    icon={
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                                            <path d="M11 4.5H18.3C19.4201 4.5 19.9802 4.5 20.408 4.71799C20.7843 4.90973 21.0903 5.21569 21.282 5.59202C21.5 6.01984 21.5 6.57989 21.5 7.7V9C21.5 9.93188 21.5 10.3978 21.3478 10.7654C21.1448 11.2554 20.7554 11.6448 20.2654 11.8478C19.8978 12 19.4319 12 18.5 12M13 19.5H5.7C4.5799 19.5 4.01984 19.5 3.59202 19.282C3.21569 19.0903 2.90973 18.7843 2.71799 18.408C2.5 17.9802 2.5 17.4201 2.5 16.3V15C2.5 14.0681 2.5 13.6022 2.65224 13.2346C2.85523 12.7446 3.24458 12.3552 3.73463 12.1522C4.10218 12 4.56812 12 5.5 12M10.3 14.5H13.7C13.98 14.5 14.12 14.5 14.227 14.4455C14.3211 14.3976 14.3976 14.3211 14.4455 14.227C14.5 14.12 14.5 13.98 14.5 13.7V10.3C14.5 10.02 14.5 9.87996 14.4455 9.773C14.3976 9.67892 14.3211 9.60243 14.227 9.5545C14.12 9.5 13.98 9.5 13.7 9.5H10.3C10.02 9.5 9.87996 9.5 9.773 9.5545C9.67892 9.60243 9.60243 9.67892 9.5545 9.773C9.5 9.87996 9.5 10.02 9.5 10.3V13.7C9.5 13.98 9.5 14.12 9.5545 14.227C9.60243 14.3211 9.67892 14.3976 9.773 14.4455C9.87996 14.5 10.02 14.5 10.3 14.5ZM17.8 22H21.2C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V17.8C22 17.52 22 17.38 21.9455 17.273C21.8976 17.1789 21.8211 17.1024 21.727 17.0545C21.62 17 21.48 17 21.2 17H17.8C17.52 17 17.38 17 17.273 17.0545C17.1789 17.1024 17.1024 17.1789 17.0545 17.273C17 17.38 17 17.52 17 17.8V21.2C17 21.48 17 21.62 17.0545 21.727C17.1024 21.8211 17.1789 21.8976 17.273 21.9455C17.38 22 17.52 22 17.8 22ZM2.8 7H6.2C6.48003 7 6.62004 7 6.727 6.9455C6.82108 6.89757 6.89757 6.82108 6.9455 6.727C7 6.62004 7 6.48003 7 6.2V2.8C7 2.51997 7 2.37996 6.9455 2.273C6.89757 2.17892 6.82108 2.10243 6.727 2.0545C6.62004 2 6.48003 2 6.2 2H2.8C2.51997 2 2.37996 2 2.273 2.0545C2.17892 2.10243 2.10243 2.17892 2.0545 2.273C2 2.37996 2 2.51997 2 2.8V6.2C2 6.48003 2 6.62004 2.0545 6.727C2.10243 6.82108 2.17892 6.89757 2.273 6.9455C2.37996 7 2.51997 7 2.8 7Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                                        </svg>
                                                                    }
                                                                />

                                                            </div>
                                                        </Col>
                                                        <Col sm={10}>
                                                            <Row className={styles.tableDataLeftAligned}>
                                                                <Col>
                                                                    <Row className={styles.pipelineInfoDiv}>
                                                                        {pipeline.is_pinned ?
                                                                            <span className={styles.pinSpan}>
                                                                                <svg style={{ marginRight: '5px' }} xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                                                                                    <path d="M2.20388 5.92381C1.82338 5.66538 1.63313 5.53616 1.57103 5.3733C1.51672 5.23088 1.52275 5.07086 1.5878 4.92803C1.6622 4.76471 1.86223 4.63417 2.26231 4.3731L5.93777 1.97462C6.33785 1.71355 6.53788 1.58301 6.71734 1.58068C6.87427 1.57865 7.02317 1.63757 7.13166 1.74463C7.25573 1.86705 7.29739 2.09323 7.38073 2.54558L7.66636 4.09611C7.67848 4.16189 7.68454 4.19478 7.69433 4.22639C7.70303 4.25447 7.71392 4.28177 7.72691 4.30806C7.74153 4.33765 7.75969 4.36548 7.79601 4.42113L8.4682 5.45122C8.53383 5.55179 8.56665 5.60207 8.60835 5.64343C8.64535 5.68013 8.68744 5.71155 8.73346 5.73682C8.78535 5.76531 8.8438 5.78315 8.96071 5.81883L10.373 6.24985C10.972 6.43265 11.2715 6.52405 11.3821 6.69322C11.4784 6.84035 11.4993 7.02529 11.439 7.19563C11.3696 7.39149 11.1003 7.5672 10.5618 7.91862L5.84108 10.9992C5.30255 11.3506 5.03329 11.5263 4.82607 11.511C4.64586 11.4976 4.485 11.404 4.38909 11.2566C4.2788 11.0872 4.31573 10.7763 4.3896 10.1544L4.56378 8.68811C4.5782 8.56673 4.58541 8.50604 4.58023 8.44708C4.57563 8.39477 4.56382 8.3436 4.54513 8.29495C4.52406 8.24012 4.49124 8.18984 4.42562 8.08927L3.75342 7.05918C3.7171 7.00353 3.69894 6.9757 3.67774 6.9504C3.65891 6.92792 3.6383 6.90696 3.6161 6.88769C3.59111 6.866 3.56345 6.84721 3.50812 6.80963L2.20388 5.92381Z" fill="#2DA6C0" />
                                                                                    <path d="M8.20144 9.45891L10.4099 12.8432M3.75342 7.05918L4.42562 8.08927C4.49124 8.18984 4.52406 8.24012 4.54513 8.29495C4.56382 8.3436 4.57563 8.39477 4.58023 8.44708C4.58541 8.50604 4.5782 8.56673 4.56378 8.68811L4.3896 10.1544C4.31573 10.7763 4.2788 11.0872 4.38909 11.2566C4.485 11.404 4.64586 11.4976 4.82607 11.511C5.03329 11.5263 5.30255 11.3506 5.84108 10.9992L10.5618 7.91862C11.1003 7.5672 11.3696 7.39149 11.439 7.19563C11.4993 7.02529 11.4784 6.84035 11.3821 6.69322C11.2715 6.52405 10.972 6.43265 10.373 6.24985L8.96071 5.81883C8.8438 5.78315 8.78535 5.76531 8.73346 5.73682C8.68744 5.71155 8.64535 5.68013 8.60835 5.64343C8.56665 5.60207 8.53383 5.55179 8.4682 5.45122L7.79601 4.42113C7.75969 4.36548 7.74153 4.33765 7.72691 4.30806C7.71392 4.28177 7.70303 4.25447 7.69433 4.22639C7.68454 4.19478 7.67848 4.16189 7.66636 4.09611L7.38073 2.54558C7.29739 2.09323 7.25573 1.86705 7.13166 1.74463C7.02317 1.63757 6.87427 1.57865 6.71734 1.58068C6.53788 1.58301 6.33785 1.71355 5.93777 1.97462L2.26231 4.3731C1.86223 4.63417 1.6622 4.76471 1.5878 4.92803C1.52275 5.07086 1.51672 5.23088 1.57103 5.3733C1.63313 5.53616 1.82338 5.66538 2.20388 5.92381L3.50812 6.80963C3.56345 6.84721 3.59111 6.866 3.6161 6.88769C3.6383 6.90696 3.65891 6.92792 3.67774 6.9504C3.69894 6.9757 3.7171 7.00353 3.75342 7.05918Z" stroke="#2DA6C0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </svg>
                                                                            </span>
                                                                            :
                                                                            null}
                                                                        <p className={styles.tableDataTwoRowPrimary} id={`adminPanel_hiringPipelines_hiringPipelineTablePipelineNameId.${i}`}>{pipeline?.pipeline_name}</p>
                                                                    </Row>
                                                                    <Row >
                                                                        <p className={styles.tableDataTwoRowSecondary} id={`adminPanel_hiringPipelines_hiringPipelineTablePipelinePositionId.${i}`}>{pipeline?.position}</p>
                                                                    </Row>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>

                                                </Col>
                                                <Col sm={1} className={styles.tableDataStatus}>
                                                    <CustomStatusLabel type={pipeline.state === 10 ? 'successStatus' : pipeline.state === 0 ? 'warningStatus' : 'dangerStatus'} label={pipeline.state === 10 ? 'Active' : pipeline.state === 0 ? 'Draft' : pipeline.state === -10 ? 'Disable' : null}></CustomStatusLabel>
                                                </Col>
                                                <Col sm={2}>
                                                    <Row className={styles.tableDataTwoRows}>
                                                        <Row >
                                                            <p className={styles.tableDataTwoRowPrimary}>{pipeline?.job_type === 10 ? "Full-Time ." : pipeline?.job_type === 20 ? "Part-Time ." : pipeline?.job_type === 30 ? "Contact/Temp ." : pipeline?.job_type === 40 ? "Casual / Vacation ." :  pipeline?.job_type === 50 ? "Internship ." :null} {pipeline.work_type === 10 ? "Remote" : pipeline.work_type === 20 ? "On-Site" : pipeline.work_type === 30 ? "Hybrid" : null}</p>
                                                        </Row>
                                                        <Row >
                                                            <p className={styles.tableDataTwoRowSecondary} id={`adminPanel_hiringPipelines_hiringPipelineTablePipelineJobLocationId.${i}`}>{pipeline.location ? pipeline.location : null}</p>
                                                        </Row>
                                                    </Row>

                                                </Col>
                                                <Col sm={2} className="d-flex justify-content-center">
                                                    <Row className={styles.tableDataCentered}>
                                                        <p className={styles.tableDataSingleRow}>
                                                            <span style={{ marginRight: '15px' }}>{pipeline?.registered_candidate_count}</span> /
                                                            <span style={{ marginRight: '15px', marginLeft: '15px' }}>{pipeline?.Pending_Offer_candidate_count}</span> /
                                                            <span style={{ marginLeft: '15px' }}>{pipeline?.hired_candidate_count}</span>
                                                        </p>
                                                    </Row>
                                                </Col>
                                                <Col sm={1}>
                                                    <Row className={styles.tableDataActions}>
                                                        {pipeline.shareable_link_enabled ?
                                                            <>
                                                                <div className={styles.tableDatActionsLeftBtns}>
                                                                    <CustomIconButton
                                                                        toolTipId={"copyShareable"}
                                                                        type="successBtn"
                                                                        showToolTip={true}
                                                                        toolTip={'copy shareable link'}
                                                                        icon={
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                                                                <g clip-path="url(#clip0_879_9755)">
                                                                                    <path d="M4.5 4V2.6C4.5 2.03995 4.5 1.75992 4.60899 1.54601C4.70487 1.35785 4.85785 1.20487 5.04601 1.10899C5.25992 1 5.53995 1 6.1 1H9.9C10.4601 1 10.7401 1 10.954 1.10899C11.1422 1.20487 11.2951 1.35785 11.391 1.54601C11.5 1.75992 11.5 2.03995 11.5 2.6V6.4C11.5 6.96005 11.5 7.24008 11.391 7.45399C11.2951 7.64215 11.1422 7.79513 10.954 7.89101C10.7401 8 10.4601 8 9.9 8H8.5M3.1 11H6.9C7.46005 11 7.74008 11 7.95399 10.891C8.14215 10.7951 8.29513 10.6422 8.39101 10.454C8.5 10.2401 8.5 9.96005 8.5 9.4V5.6C8.5 5.03995 8.5 4.75992 8.39101 4.54601C8.29513 4.35785 8.14215 4.20487 7.95399 4.10899C7.74008 4 7.46005 4 6.9 4H3.1C2.53995 4 2.25992 4 2.04601 4.10899C1.85785 4.20487 1.70487 4.35785 1.60899 4.54601C1.5 4.75992 1.5 5.03995 1.5 5.6V9.4C1.5 9.96005 1.5 10.2401 1.60899 10.454C1.70487 10.6422 1.85785 10.7951 2.04601 10.891C2.25992 11 2.53995 11 3.1 11Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                </g>
                                                                                <defs>
                                                                                    <clipPath id="clip0_879_9755">
                                                                                        <rect width="12" height="12" transform="translate(0.5)" />
                                                                                    </clipPath>
                                                                                </defs>
                                                                            </svg>
                                                                        }
                                                                        handleClick={() => copyURL(pipeline?.link)}
                                                                    />
                                                                </div>
                                                                <div className={styles.tableDatActionsLeftBtns}>
                                                                    <CustomIconButton
                                                                        toolTipId={"openShareable"}
                                                                        type="successBtn"
                                                                        showToolTip={true}
                                                                        toolTip={'open shareable link'}
                                                                        icon={
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                                                                <path d="M11 4.5L11 1.5M11 1.5H7.99999M11 1.5L6.5 6M5.5 1.5H4.4C3.55992 1.5 3.13988 1.5 2.81901 1.66349C2.53677 1.8073 2.3073 2.03677 2.16349 2.31901C2 2.63988 2 3.05992 2 3.9V8.1C2 8.94008 2 9.36012 2.16349 9.68099C2.3073 9.96323 2.53677 10.1927 2.81901 10.3365C3.13988 10.5 3.55992 10.5 4.4 10.5H8.6C9.44008 10.5 9.86012 10.5 10.181 10.3365C10.4632 10.1927 10.6927 9.96323 10.8365 9.68099C11 9.36012 11 8.94008 11 8.1V7" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                        }
                                                                        handleClick={() => navigateURL(pipeline?.link)}

                                                                    />
                                                                </div>
                                                            </>
                                                            :
                                                            <div >
                                                                <p className={styles.pipelineShareLinkInactive}>Inactive</p>
                                                            </div>
                                                        }

                                                    </Row>
                                                </Col>
                                                <Col sm={1} className="d-flex justify-content-center">
                                                    <Row className={styles.tableDataCentered}>
                                                        <p className={styles.tableDataSingleRow}>{moment(pipeline?.created_at).format("MMM YYYY")}</p>
                                                    </Row>
                                                </Col>
                                                <Col sm={1} className="d-flex justify-content-center">
                                                    <Row className={styles.tableOptionRow}>
                                                        <div >
                                                            <Dropdown
                                                                alignRight={true}
                                                                id="adminPanel_hiringPipelines_createPipelineModal_viewPipeline_actionDropdownDotsId"
                                                            >
                                                                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu className={styles.dropdownMenu}>
                                                                    <Dropdown.Item onClick={() => viewPipeline(pipeline.pipeline_id)} className={styles.dropdownText} id="adminPanel_hiringPipelines_createPipelineModal_viewPipeline_actionDropdownViewOptionId">View</Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => editPipelineBtnClicked(pipeline.pipeline_id)} className={styles.dropdownText} id="adminPanel_hiringPipelines_createPipelineModal_viewPipeline_actionDropdownEditOptionId">Edit</Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => onClickClone(pipeline.pipeline_id)} className={styles.dropdownText} id="adminPanel_hiringPipelines_createPipelineModal_viewPipeline_actionDropdownCloneOptionId">Clone</Dropdown.Item>
                                                                    {pipeline.is_pinned ?
                                                                        <Dropdown.Item onClick={() => { changePinState(pipeline.pipeline_id, false) }} className={styles.dropdownText}>Unpin Pipeline</Dropdown.Item>
                                                                        :
                                                                        <Dropdown.Item onClick={() => { changePinState(pipeline.pipeline_id, true) }} className={styles.dropdownText}>Pin Pipeline</Dropdown.Item>
                                                                    }
                                                                    {pipeline.shareable_link_enabled ?
                                                                        <Dropdown.Item onClick={() => { changeShareableLinkState(pipeline.pipeline_id, true) }} className={(pipeline.state === -10) ? styles.dropdownTextDisabled : styles.dropdownText} disabled={(pipeline.state === -10) ? true : false}>Disable shareble link</Dropdown.Item>
                                                                        :
                                                                        <Dropdown.Item onClick={() => { changeShareableLinkState(pipeline.pipeline_id, false) }} className={(pipeline.state === -10) ? styles.dropdownTextDisabled : styles.dropdownText} disabled={(pipeline.state === -10) ? true : false}>Activate shareble Link</Dropdown.Item>
                                                                    }


                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            </div>
                                        );

                                    })
                                    }

                                </div>)}
                        {filteredValues.length > 9 && isPageDataLoading === false &&
                            <div className={styles.bottomTableDiv}>
                                <div className={styles.bottomTableControlsWrapper}>

                                    <div className={styles.bottomTableControlsNextBtn}>
                                        <CustomButton
                                            id="hiring_pipelines_go_to_previous_page_btn"
                                            label="Previous"
                                            type="defaultSmallBtn"
                                            handleClick={handlePreviousClick}
                                            disabled={currentPage === 1}
                                        />
                                    </div>
                                    <div>
                                        <CustomButton
                                            id="hiring_pipelines_go_to_next_page_btn"
                                            label="Next"
                                            type="defaultSmallBtn"
                                            handleClick={handleNextClick}
                                            disabled={currentPage === Math.ceil(filteredValues.length / itemsPerPage)}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <span className={styles.paginationInfo}>
                                        Page {currentPage} of {totalPages}
                                    </span>
                                </div>

                            </div>
                        }

                    </div>

                </div>)
            }
        </div>
    )
}

export default HiringPipelines;
